const loading = {}

// Injects a <script> once per src and resolves when it has loaded. A failed load is forgotten so
// a later call can try again.
export default function loadScript (src) {
  if (!loading[src]) {
    loading[src] = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = src
      script.async = true
      script.onload = resolve
      script.onerror = () => {
        delete loading[src]
        reject(new Error(`Failed to load ${src}`))
      }
      document.head.appendChild(script)
    })
  }
  return loading[src]
}
